/** 新建数据集表单默认值（与后端 DataSetCO 字段映射一致）。 */
export function createEmptyDataRuleForm() {
  return {
    name: '',
    relationApp: '',
    country: { isExclude: true, countries: [] },
    appVersion: { start: '', end: '', skip: '' },
    apiVersion: { start: '', end: '', skip: '' },
    remarks: '',
    key: '',
    status: '',
  }
}

export const DATA_FORM_RULES = {
  name: [{ required: true, message: '请输入数据集的名称', trigger: 'blur' }],
  relationApp: [{ required: true, message: '请选择关联应用', trigger: 'change' }],
}

export function parseVersionJson(raw) {
  if (!raw) {
    return { start: '', end: '', skip: '' }
  }
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return {
      start: parsed.start ?? '',
      end: parsed.end ?? '',
      skip: parsed.skip ?? '',
    }
  } catch (error) {
    return { start: '', end: '', skip: '' }
  }
}

export function parseCountryJson(raw) {
  if (!raw) {
    return { isExclude: true, countries: [] }
  }
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return {
      isExclude: parsed.isExclude !== false,
      countries: Array.isArray(parsed.countries) ? parsed.countries : [],
    }
  } catch (error) {
    return { isExclude: true, countries: [] }
  }
}

export function parseDataRelationList(raw) {
  if (!raw) return []
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return Array.isArray(parsed) ? parsed : []
  } catch (error) {
    return []
  }
}

export function mapDataDetailToForm(data) {
  const source = data || {}
  return {
    name: source.name || '',
    relationApp: source.appId || '',
    key: source.key || '',
    status: source.status,
    country: parseCountryJson(source.country),
    appVersion: parseVersionJson(source.appVersion),
    apiVersion: parseVersionJson(source.apiVersion),
    remarks: source.comment || '',
  }
}

/**
 * 保存前校验数据关联：每项须选择页面。
 * 修正旧逻辑仅检查最后一项的问题。
 */
export function validateDataRelationList(list) {
  if (!list || !list.length) {
    return { valid: false, message: '数据关联为空，请先选择关联应用' }
  }
  const missing = list.find((item) => !item.pageId)
  if (missing) {
    return { valid: false, message: '数据关联中还有页面选项未选择' }
  }
  return { valid: true }
}
